<div fxLayout="column" fxLayoutGap="5px" class="desktop">
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px">
        <div fxFlex="50%" i18n>
            <input type="checkbox" [checked]="checkboxes[CONGESTION]" (change)="toggleCheckbox('CONGESTION')"> <img src="assets/img/CONGESTION.svg">Congestión
        </div>
        <div fxFlex="50%" i18n>
            <input type="checkbox" [checked]="checkboxes[CONES]" (change)="toggleCheckbox('CONES')"> <img src="assets/img/CONES.svg">Conos
        </div>
    </div>
    <div fxLayout="row" fxLayoutGap="15px">
        <div fxFlex="50%" i18n>
            <input type="checkbox" [checked]="checkboxes[ROADWORKS]" (change)="toggleCheckbox('ROADWORKS')"><img src="assets/img/ROADWORKS.svg">Obras
        </div>
        <div fxFlex="50%" i18n>
            <input type="checkbox" [checked]="checkboxes[INCIDENT]" (change)="toggleCheckbox('INCIDENT')"> <img src="assets/img/INCIDENT.svg">Incidencias
        </div>
    </div>
    <div fxLayout="row" fxLayoutGap="15px">
        <div fxFlex="50%" i18n>
            <input type="checkbox" [checked]="checkboxes[METEO]" (change)="toggleCheckbox('METEO');"> <img src="assets/img/METEO.svg">Meteorología
        </div>
        <div fxFlex="50%" i18n>
            <input type="checkbox" [checked]="checkboxes[CAMERA]" (change)="toggleCheckbox('CAMERA')"><img src="assets/img/CAMERA.svg">Cámaras
        </div>
    </div>
    <div fxLayout="row" fxLayoutGap="15px">
        <div fxFlex="50%" i18n>
            <input type="checkbox" [checked]="checkboxes[MOUNTAINPASS]" (change)="toggleCheckbox('MOUNTAINPASS')"> <img src="assets/img/MOUNTAINPASS.svg">Puertos de montaña
        </div>
    </div>
</div>

<!------------------------------------------------------------------------------------------------------------------------------->


<div fxLayout="column" class="responsive-landscape-container" fxLayoutAlign="space-between center" fxLayoutGap="13px">

    <div class="alerta-button" (click)="toggleCheckbox('CONGESTION')" [class.checked]="checkboxes[CONGESTION]" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
        <img src="assets/img/CONGESTION.svg" width="25px">
        <div i18n>
            Congestión
        </div>
    </div>

    <div class="alerta-button" (click)="toggleCheckbox('CONES')" [class.checked]="checkboxes[CONES]" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
        <img src="assets/img/CONES.svg" width="25px">
        <div i18n>
            Conos
        </div>
    </div>

    <div class="alerta-button" (click)="toggleCheckbox('ROADWORKS')" [class.checked]="checkboxes[ROADWORKS]" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
        <img src="assets/img/ROADWORKS.svg" width="25px">
        <div i18n>
            Obras
        </div>
    </div>

    <div class="alerta-button" (click)="toggleCheckbox('INCIDENT')" [class.checked]="checkboxes[INCIDENT]" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
        <img src="assets/img/INCIDENT.svg" width="25px">
        <div i18n>
            Incidencias
        </div>
    </div>

    <div class="alerta-button" (click)="toggleCheckbox('METEO')" [class.checked]="checkboxes[METEO]" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
        <img src="assets/img/METEO.svg" width="25px">
        <div i18n>
            Meteo
        </div>
    </div>

    <div class="alerta-button" (click)="toggleCheckbox('CAMERA')" [class.checked]="checkboxes[CAMERA]" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
        <img src="assets/img/CAMERA.svg" width="25px">
        <div i18n>
            Cámaras
        </div>
    </div>

    <div class="alerta-button" (click)="toggleCheckbox('MOUNTAINPASS')" [class.checked]="checkboxes[MOUNTAINPASS]" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
        <img src="assets/img/MOUNTAINPASS.svg" width="25px">
        <div i18n>
            Puertos
        </div>
    </div>

</div>


<!------------------------------------------------------------------------------------------------------------------------------->


<div fxLayout="row" class="responsive-container" fxLayoutAlign="space-between center" fxLayoutGap="13px">

    <div class="alerta-button" (click)="toggleCheckbox('CONGESTION')" [class.checked]="checkboxes[CONGESTION]" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
        <img src="assets/img/CONGESTION.svg" width="25px">
        <div i18n>
            Congestión
        </div>
    </div>

    <div class="alerta-button" (click)="toggleCheckbox('CONES')" [class.checked]="checkboxes[CONES]" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
        <img src="assets/img/CONES.svg" width="25px">
        <div i18n>
            Conos
        </div>
    </div>

    <div class="alerta-button" (click)="toggleCheckbox('ROADWORKS')" [class.checked]="checkboxes[ROADWORKS]" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
        <img src="assets/img/ROADWORKS.svg" width="25px">
        <div i18n>
            Obras
        </div>
    </div>

    <div class="alerta-button" (click)="toggleCheckbox('INCIDENT')" [class.checked]="checkboxes[INCIDENT]" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
        <img src="assets/img/INCIDENT.svg" width="25px">
        <div i18n>
            Incidencias
        </div>
    </div>

    <div class="alerta-button" (click)="toggleCheckbox('METEO')" [class.checked]="checkboxes[METEO]" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
        <img src="assets/img/METEO.svg" width="25px">
        <div i18n>
            Meteo
        </div>
    </div>

    <div class="alerta-button" (click)="toggleCheckbox('CAMERA')" [class.checked]="checkboxes[CAMERA]" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
        <img src="assets/img/CAMERA.svg" width="25px">
        <div i18n>
            Cámaras
        </div>
    </div>

    <div class="alerta-button" (click)="toggleCheckbox('MOUNTAINPASS')" [class.checked]="checkboxes[MOUNTAINPASS]" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
        <img src="assets/img/MOUNTAINPASS.svg" width="25px">
        <div i18n>
            Puertos
        </div>
    </div>

</div>


    
